module.exports = __webpack_public_path__ + "img/indu_17.fb07c4a5.png";